$(document).ready(function() {
  const inputs            = document.querySelectorAll('input:not([type=hidden])');
  const loginButton       = document.querySelector('.submit-button');
  const buttonLater       = document.querySelector('#submit-later');
  const isConfirmationPin = undefined;

  if (loginButton != null) {
    const isConfirmationPin = loginButton.dataset['isConfirmationPin'];

    inputs.forEach(function(input) {
      input.addEventListener('input', function() {
        let allFilled = true;

        inputs.forEach(function(input) {
          if (input.type === 'checkbox' || input.type === 'radio' ) {
            if (!input.checked) {
              allFilled = false;
            }
          } else {
            if (input.value.trim() === '') {
              allFilled = false;
            }
          }
        });

        if (allFilled) {
          loginButton.disabled = false;
          loginButton.classList.remove("disabled")

          if (buttonLater) {
            buttonLater.disabled = false;
            buttonLater.classList.remove("disabled")
          }

          verifyConfirmationPin()
        } else {
          loginButton.disabled = true;
          loginButton.classList.add("disabled")

          if (buttonLater) {
            buttonLater.disabled = true;
            buttonLater.classList.add("disabled")
          }
        }
      });
    });

    if (isConfirmationPin != undefined) {
      var pin = document.querySelector('#pin')
      if (pin.dataset['secrect'] == "true") {
        var encryptPin = btoa(pin.value)
        pin.value = encryptPin
      }
    }
  }

  function verifyConfirmationPin() {
    setTimeout(function(){
      if (isConfirmationPin != undefined) {
        var pinElement      = document.querySelector('#pin')
        var pin             = pinElement.value
        var confirmationPin = document.querySelector('#append-pin-code').value
        var errorMessage    = document.querySelector('#error-message')

        if (pinElement.dataset['secrect'] == 'true') {
          pin = atob(pinElement.value)
        }

        if (pin == confirmationPin) {
          loginButton.disabled = false;
          loginButton.classList.remove("disabled")

          if (errorMessage != null) {
            errorMessage.classList.add('d-none')
          }
        } else {
          loginButton.disabled = true;
          loginButton.classList.add("disabled")

          if (errorMessage != null) {
            errorMessage.classList.remove("d-none")
          }
        }
      }
    }, 200);
    return false;
  }
})